<script>
  import { Router, Route } from "svelte-routing";
  import Home from "./components/pages/Home.svelte";
  import Login from "./components/pages/Login.svelte";
  import Job from "./components/pages/JobBoard.svelte";
  import Reports from "./components/pages/Reports.svelte";
  import Hours from "./components/pages/Hours.svelte";
  import PTO from "./components/pages/PTO.svelte";
  import Resourcing from "./components/pages/Resourcing.svelte";
  import RequestPTO from "./components/pages/RequestPTO.svelte";
  import Approve from "./components/pages/Approve.svelte";
  import Deny from "./components/pages/Deny.svelte";
  import Error404 from "./components/pages/Error.svelte";
  import FieldVerification from "./components/pages/FieldVerification.svelte";
  import PTOApproval from "./components/pages/PTOApproval.svelte";

  import { onMount } from "svelte";
  export let url = "";
</script>

<Router {url}>
  <div>
    <Route path="/Login" component={Login} />
    <Route path="/login" component={Login} />
    <Route path="/Timesheet" component={Home} />
    <Route path="/timesheet" component={Home} />
    <Route path="/ptoapproval" component={PTOApproval} />
    <Route path="/timesheet" component={Home} />
    <Route path="/Board" component={Job} />
    <Route path="/board" component={Job} />
    <Route path="/reports" component={Reports} />
    <Route path="/Reports" component={Reports} />
    <Route path="/reports/hours" component={Hours} />
    <Route path="/reports/pto" component={PTO} />
    <Route path="/Inprocess" component={Resourcing} />
    <Route path="/inprocess" component={Resourcing} />
    <Route path="/RequestPTO" component={RequestPTO} />
    <Route path="/requestPTO" component={RequestPTO} />
    <Route path="/Approved" component={Approve} />
    <Route path="/approved" component={Approve} />
    <Route path="/fieldverification" component={FieldVerification} />
    <Route path="/Denied" component={Deny} />
    <Route path="/denied" component={Deny} />
    <Route path="/Error404" component={Error404} />
    <Route path="/error404" component={Error404} />
  </div>
</Router>
